import React from "react";
import { MenuItem, Button, Icon } from "@blueprintjs/core";
import { ItemRenderer, Select } from "@blueprintjs/select";
import styled from "styled-components";
import { LanguageDefinition, VISIBLE_LANGUAGES, Language } from "../../../lang";

const LanguageSingleSelect = Select.ofType<LanguageDefinition>();

const LangButton = styled(Button)`
  color: #7a6bcb !important;
  font-size: var(--global-font-size-xs);
  min-height: unset;
  height: 24px;
  padding: 8px;
  margin-right: 4px;
`;

const Item = styled(MenuItem)`
  font-size: var(--global-font-size-xs);
  padding: 2px;
  line-height: var(--global-font-size-s);
`;

const renderExample: ItemRenderer<LanguageDefinition> = (
  example,
  { modifiers, handleClick }
) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <Item
      active={modifiers.active}
      key={example.name}
      onClick={handleClick}
      text={<span>{example.name}</span>}
      shouldDismissPopover={false}
    />
  );
};

interface Props {
  onChange: (language: Language) => void;
  value: Language;
  disabled?: boolean;
}

const LanguageSelect: React.FC<Props> = ({
  onChange,
  value,
  disabled = false,
}) => {
  const langs: LanguageDefinition[] = Object.values(VISIBLE_LANGUAGES);

  const friendlySelectLanguage: string = (Object.entries(
    VISIBLE_LANGUAGES
  ).find(([id, _]) => id === value) ?? [undefined, { name: "unknown" }])[1]
    .name;

  return (
    <LanguageSingleSelect
      items={disabled ? [] : langs}
      itemRenderer={renderExample}
      filterable={false}
      noResults={<Item disabled={true} text="no examples." />}
      onItemSelect={(selected: LanguageDefinition) => onChange(selected.id)}
      popoverProps={{
        minimal: true,
        position: "bottom-right",
      }}
    >
      <LangButton minimal>
        {friendlySelectLanguage}
        <Icon
          icon={"chevron-down"}
          size={16}
          color={"#7a6bcb"}
          style={{ marginLeft: "2px" }}
        />
      </LangButton>
    </LanguageSingleSelect>
  );
};

export default LanguageSelect;
